import request from "@/utils/request";

//查看附近车辆
export function listNearbyUsers(data) {
    return request({
        url: "/Personal/listNearbyUsers",
        method: "post",
        data
    });
}

//查找滑板车
export function searchScooter(data) {
    return request({
        url: "/Personal/searchScooter",
        method: "post",
        data
    });
}

//修改共享地图状态
export function updateShareMapStatus(data) {
    return request({
        url: "/Personal/updateShareMapStatus",
        method: "post",
        data
    });
}

